module.exports = __webpack_public_path__ + "static/img/Edu.-Qualification.e4cbe770.png";